import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import LandingPage from "./pages/LandingPage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ServicePage from "./pages/ServicePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ApplicationMain from "./pages/ApplicationMain";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <Routes>
          {/* Landing Page Route - No regular navigation */}
          <Route
            path="/lp"
            element={
              <>
                <Navbar isLandingPage={true} />
                <LandingPage />
              </>
            }
          />

          {/* Application Success Page - No Footer */}
          <Route
            path="/application/main"
            element={
              <>
                <Navbar />
                <ApplicationMain />
              </>
            }
          />

          {/* Main Website Routes */}
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/services/:service" element={<ServicePage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                </Routes>
                <Footer />
              </>
            }
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
